<div class="modal-backdrop" *ngIf="aberto" (click)="onClose()"></div>
<div class="modal" *ngIf="aberto" (click)="onClose()">
  <div class="modal-card" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <div class="modal-header__left">
        <div class="modal-title-row">
          <div class="modal-title">Orçamento {{ getNumeroOrcamento() }}</div>
          <span
            class="status-chip"
            [ngStyle]="{
              'border-color': getStatusColor(getStatusLabel()),
              color: getStatusColor(getStatusLabel()),
              'background-color': getStatusColor(getStatusLabel()) + '1F',
            }"
          >
            {{ getStatusLabel() }}
          </span>
        </div>
        <div class="modal-subtitle">{{ getSubtituloVeiculo() }}</div>
      </div>
      <button type="button" class="btn-close" (click)="onClose()"></button>
    </div>

    <div class="modal-body">
      <div class="modal-section">
        <div class="section-title">Informa—ões</div>
        <div class="info-grid">
          <div class="info-item">
            <div class="info-label">Placa</div>
            <div class="info-value">{{ lead?.placa || '—' }}</div>
          </div>
          <div class="info-item">
            <div class="info-label">Marca</div>
            <div class="info-value">{{ lead?.marca || '—' }}</div>
          </div>
          <div class="info-item">
            <div class="info-label">Modelo</div>
            <div class="info-value">{{ lead?.modelo || '—' }}</div>
          </div>
          <div class="info-item">
            <div class="info-label">Cliente</div>
            <div class="info-value">{{ lead?.clienteNome || '—' }}</div>
          </div>
          <div class="info-item">
            <div class="info-label">Consultor</div>
            <div class="info-value">{{ getConsultorNome() }}</div>
          </div>
          <div class="info-item">
            <div class="info-label">Status</div>
            <div class="info-value">{{ getStatusLabel() }}</div>
          </div>
          <div class="info-item">
            <div class="info-label">Valor</div>
            <div class="info-value" *ngIf="getValor() !== null; else semValor">
              {{ getValor() | currency: 'BRL' : 'symbol' : '1.2-2' }}
            </div>
            <ng-template #semValor>
              <div class="info-value">—</div>
            </ng-template>
          </div>
          <div class="info-item">
            <div class="info-label">Abertura</div>
            <div class="info-value" *ngIf="getDataAbertura() as abertura; else semAbertura">
              {{ abertura | date: 'dd/MM/yyyy' }}
            </div>
            <ng-template #semAbertura>
              <div class="info-value">—</div>
            </ng-template>
          </div>
        </div>
      </div>

      <div class="modal-section">
        <div class="field">
          <label class="form-label">Tipo de contato</label>
          <select class="form-select" [(ngModel)]="tipoContato">
            <option value="TELEFONE">Telefone</option>
            <option value="WHATSAPP">WhatsApp</option>
            <option value="EMAIL">E-mail</option>
          </select>
        </div>
        <div class="field">
          <label class="form-label">Observacao</label>
          <textarea class="form-control" rows="3" [(ngModel)]="observacao"></textarea>
        </div>
        <div class="field">
          <label class="form-label">Numero OS</label>
          <input class="form-control" type="text" />
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button class="btn btn-primary" (click)="onEncerrar()">Encerrar</button>
      <button class="btn btn-success" (click)="onEncerrar()">Gerar OS</button>
      <button class="btn btn-success" (click)="onSalvar()">Salvar</button>
    </div>
  </div>
</div>
